/*eslint-disable import/default */
import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import configureStore from './store/configureStore.dev';
import {Provider} from 'react-redux';
import {Router, browserHistory} from 'react-router';
import {syncHistoryWithStore, routerActions} from 'react-router-redux';
import routes from './routes';
import {loadTimesheets, getCurrentDate} from './actions/timesheetAction';
import {getCurrentUser} from './actions/authAction';
import moment from 'moment';
import injectTapEventPlugin from 'react-tap-event-plugin';
import './styles/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'toastr/build/toastr.min.css';
import 'fixed-data-table/dist/fixed-data-table.min.css';
injectTapEventPlugin();

moment.locale('fr');
const store = configureStore();
store.dispatch(getCurrentDate());
store.dispatch(getCurrentUser());
store.dispatch(loadTimesheets());

const history = syncHistoryWithStore(browserHistory, store);
let state = store.getState();

render(
    <Provider store={store}>
        <Router history={history} routes={routes}/>
    </Provider>,
    document.getElementById('app')
);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/